require('./RASuitabilityTestZeroQuestionLegalText.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

class RASuitabilityTestZeroQuestionLegalText extends React.Component {
    render() {
        const { clientName } = this.props;

        return (
            <BlockInfo extraClass="ra-suitability-test-zero-question-legal-text__block-info">
                <p>
                    <FormattedText
                        value="raSuitabilityTestZeroQuestion-legalText1"
                        injectedStrings={[clientName]}
                    />
                </p>
                <p>
                    <FormattedText value="raSuitabilityTestZeroQuestion-legalText2" />
                </p>
                <p>
                    <FormattedText value="raSuitabilityTestZeroQuestion-legalText3" />
                </p>
                <p>
                    <FormattedText value="raSuitabilityTestZeroQuestion-legalText4" />
                </p>
                <p>
                    <FormattedText
                        value="raSuitabilityTestZeroQuestion-legalText5"
                        injectedStrings={[clientName]}
                    />
                </p>
            </BlockInfo>
        );
    }
}

RASuitabilityTestZeroQuestionLegalText.propTypes = {
    clientName: PropTypes.string.isRequired,
};

module.exports = RASuitabilityTestZeroQuestionLegalText;
